import { render, staticRenderFns } from "./ContentBlockActions.vue?vue&type=template&id=578d87c3&scoped=true&"
import script from "./ContentBlockActions.vue?vue&type=script&lang=js&"
export * from "./ContentBlockActions.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockActions.vue?vue&type=style&index=0&id=578d87c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d87c3",
  null
  
)

export default component.exports